import { useReleaseFlag } from 'hooks/useReleaseFlags';
import { ENV } from 'shared/ENV';

/**
 * Domain that serves the static tile cache (`/maptiles/...` and the PurpleAir `/v1/sensors` proxy).
 */
export const useStaticTileCacheDomain = (): string => {
  const useAlternateStaticTileCache = useReleaseFlag(
    'use_alternate_static_tile_cache_domain',
  );

  if (useAlternateStaticTileCache) {
    return ENV.VITE_ALTERNATE_STATIC_TILE_CACHE_DOMAIN;
  }
  return ENV.VITE_STATIC_TILE_CACHE_DOMAIN;
};
